import React, {Component} from 'react';
import {connect} from 'react-redux';
import {ScreenNotificationDefault, Footer} from '../../components';
import {
  redirectToYourCard,
  redirectToTermsAccept,
  redirectToSignature,
  redirectToValidationAccessCode,
} from '../../ducks/Navigate';
import {
  consultarSegurosDisponiveis,
  updateSeguroContratado,
  adicionarSeguroContratado,
  processaSituacaoPortadorFinalizada,
  processarAutorizacao,
} from '../../ducks/Customer';
import {NotificationService, StringService} from '../../services';
import NumberFormat from 'react-number-format';
import renderHTML from 'react-render-html';

import './styles.scss';
import {trim} from 'jquery';
import {Messages, RouteKeys} from '../../constants';

class HireInsurance extends Component {
  state = {
    emailChanged: false,
    numeroTentativas: 1,
    notification: null,
  };

  async componentDidMount() {
    document.title = StringService.formatTitle(RouteKeys.HireInsurance.title);

    console.log(`CHAVE -> ${JSON.stringify(this.props.chave)}`);

    if (
      !(await this.props.processaSituacaoPortadorFinalizada(this.props.chave))
    ) {
      let encontrado = this.props.segurosDisponiveis.map((seguros, indice) => {
        if (seguros.codigo === this.props.seguroContratado.codigo) {
          return (encontrado = true);
        }
        return false;
      });
      // se n foi encontrado, limpamos a propriedade de cache
      if (!encontrado) {
        let seguroContratado = [];
        this.props.updateSeguroContratado({
          prop: 'seguroContratado',
          value: seguroContratado,
        });
      }
    }

    //diminir a altura do cabeçalho que é um componente
    document.getElementsByClassName('header')[0].style.maxHeight = '3em';
  }

  iniciarProcessoAutorizacoes = () => {
    let notification = NotificationService.showMessageWithoutButton(
      'Estamos preparando o seu contrato para a assinatura digital.',
    );
    this.setState({notification});
  };

  finalizarProcessoAutorizacoes = () => {
    this.state.notification.close();
    let numeroTentativas = 1;
    this.setState({numeroTentativas});
  };

  processaAutorizacao = async () => {
    if (
      !(await this.props.processaSituacaoPortadorFinalizada(this.props.chave))
    ) {
      let chave = this.props.chave;
      const dados = {
        chave,
        autorizacao: [],
      };
      const processarAutorizacaoResponse =
        await this.props.processarAutorizacao(dados);
      let registrarDenovo = false;

      if (!processarAutorizacaoResponse.sucesso) {
        if (this.state.numeroTentativas < 5) {
          registrarDenovo = true;
        } else {
          this.finalizarProcessoAutorizacoes();

          NotificationService.showValidationSingleError(
            Messages.ErrorTryAgainMessage,
          ).then(() => {
            this.props.redirectToValidationAccessCode();
          });
        }

        let {numeroTentativas} = this.state;
        numeroTentativas++;
        this.setState({numeroTentativas});

        if (registrarDenovo) {
          setTimeout(this.processaAutorizacao, 10000);
        }
      } else {
        this.finalizarProcessoAutorizacoes();
        this.props.redirectToSignature();
      }
    } else this.finalizarProcessoAutorizacoes();
  };

  async nextHandle(chave, seguroContratado) {
    if (seguroContratado !== null) {
      await this.props.adicionarSeguroContratado(chave, seguroContratado);

      this.props.redirectToTermsAccept();
    } else {
      await this.props.adicionarSeguroContratado(chave, null);
      this.iniciarProcessoAutorizacoes();
      this.processaAutorizacao();
    }
  }

  handleChange = (prop, value) => {
    if (value === this.props.seguroContratado.codigo) {
      value = '';
    }

    let seguroContratado =
      value !== ''
        ? this.props.segurosDisponiveis.filter((s) => s.codigo === value)[0]
        : [];
    value = seguroContratado;

    this.props.updateSeguroContratado({prop, value});
  };

  render() {
    const {bannerSeguros, bannerSegurosMobile} = this.props.graphql;
    return (
      <ScreenNotificationDefault
        contentCustom={
          <div className="div-hire-insurance">
            <div className="div-textos">
              <strong>
                <h4 id="credz-protecao">CREDZ PROTEÇÃO</h4>
              </strong>
              <p className="texto-protecao">
                Proteções para você, sua família, seu veículo ou sua casa a
                partir de R$ 6,99!
              </p>
            </div>
            <div className="div-imagem-desktop">
              {bannerSeguros.url_image && bannerSeguros.url_image !== '' && (
                <img
                  src={bannerSeguros.url_image}
                  alt={bannerSeguros.alt_image}
                />
              )}
            </div>
            <div className="div-imagem-mobile">
              {bannerSegurosMobile.url_image &&
                bannerSegurosMobile.url_image !== '' && (
                  <img
                    src={bannerSegurosMobile.url_image}
                    alt={bannerSegurosMobile.alt_image}
                  />
                )}
            </div>
            <div className="div-titulo">
              <p id="nossos-planos-protecao">Nossos Planos</p>
              <p id="texto-explicativo">
                Escolha os benefícios e coberturas adequados para a proteção do
                que é mais importante para você.
              </p>
            </div>
            <br />
            <div className="grid-protecao">
              {this.props.segurosDisponiveis &&
                this.props.segurosDisponiveis.map((seguros, indice) => (
                  <div
                    onClick={() =>
                      this.handleChange('seguroContratado', seguros.codigo)
                    }
                    className="item-protecao"
                    key={indice}
                  >
                    <div
                      style={{
                        backgroundColor:
                          this.props.seguroContratado &&
                          seguros.codigo ===
                            this.props.seguroContratado.codigo &&
                          seguros.cor,
                      }}
                      className="cabecalho-protecao"
                    >
                      <p id={seguros.codigo}>{seguros.nome}</p>
                    </div>
                    <div className="conteudo-protecao">
                      <NumberFormat
                        value={seguros.valor}
                        className={''}
                        displayType={'text'}
                        decimalSeparator={','}
                        thousandSeparator={'.'}
                        prefix={'R$'}
                        fixedDecimalScale
                        decimalScale={2}
                      />
                    </div>
                    <div className="check-protecao">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        style={{
                          fill:
                            this.props.seguroContratado &&
                            seguros.codigo ===
                              this.props.seguroContratado.codigo &&
                            seguros.cor,
                        }}
                        viewBox="0 0 24 24"
                      >
                        <path fill="none" d="M0 0h24v24H0V0z"></path>
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8z"></path>
                      </svg>
                    </div>
                  </div>
                ))}
            </div>

            <div className="div-observacao-seguro">
              <p>
                {this.props.seguroContratado &&
                  this.props.seguroContratado.id !== 0 &&
                  this.props.seguroContratado.nome && (
                    <strong>
                      PROTEÇÃO
                      <span
                        style={{
                          color:
                            this.props.seguroContratado &&
                            this.props.seguroContratado.cor !== '' &&
                            this.props.seguroContratado.cor,
                        }}
                      >
                        {' '}
                        {this.props.seguroContratado.nome.replace(
                          'PROTEÇÃO',
                          '',
                        )}
                      </span>
                    </strong>
                  )}
              </p>

              {this.props.seguroContratado &&
                this.props.seguroContratado.id !== 0 &&
                this.props.seguroContratado.valor && (
                  <p>
                    <strong>
                      Apenas{' '}
                      <NumberFormat
                        value={this.props.seguroContratado.valor}
                        className={'bold'}
                        displayType={'text'}
                        decimalSeparator={','}
                        thousandSeparator={'.'}
                        prefix={'R$'}
                        fixedDecimalScale
                        decimalScale={2}
                      />{' '}
                      /mês.
                    </strong>
                  </p>
                )}

              {this.props.seguroContratado &&
              this.props.seguroContratado.id !== 0 &&
              this.props.seguroContratado.descricao ? (
                <div className="conteudo-seguro">
                  <div className="descricao-seguro">
                    {renderHTML(trim(this.props.seguroContratado.descricao))}
                  </div>
                </div>
              ) : (
                <div className="conteudo-seguro">
                  <p className="descricao-seguro defaut">
                    <strong>Pague com seu Credz Visa!</strong>
                    <br />
                    <br />
                    Você não precisa se preocupar com boletos, a mensalidade vem
                    direto na fatura do seu Cartão.
                    <br />
                    Lembrando que a contratação destes produtos é opcional.
                  </p>
                </div>
              )}
            </div>
          </div>
        }
        contentButtons={
          <div className="div-hire-insurance">
            <Footer
              nextForm="frm"
              backHandle={() => {
                this.props.redirectToYourCard();
              }}
              nextHandle={async () => {
                if (
                  !(await this.props.processaSituacaoPortadorFinalizada(
                    this.props.chave,
                  ))
                ) {
                  var {chave, seguroContratado} = this.props;

                  if (
                    this.props.seguroContratado &&
                    this.props.seguroContratado.codigo &&
                    this.props.seguroContratado.codigo !== ''
                  ) {
                    NotificationService.showConfirm(
                      `Deseja confirmar a adesão ao <strong> ${this.props.seguroContratado.nome} </strong>?`,
                      'Confirmar',
                      'Cancelar',
                    ).then((result) => {
                      if (result.value && result.value === true) {
                        this.nextHandle(chave, seguroContratado);
                      }
                    });
                  } else {
                    this.nextHandle(chave, null);
                  }
                }
              }}
            />
          </div>
        }
      />
    );
  }
}

const mapStateToProps = ({graphql, customer}) => {
  const {segurosDisponiveis, chave, situacao, seguroContratado} = customer;
  return {graphql, segurosDisponiveis, chave, situacao, seguroContratado};
};

export default connect(mapStateToProps, {
  redirectToYourCard,
  redirectToTermsAccept,
  redirectToSignature,
  redirectToValidationAccessCode,
  consultarSegurosDisponiveis,
  updateSeguroContratado,
  adicionarSeguroContratado,
  processaSituacaoPortadorFinalizada,
  processarAutorizacao,
})(HireInsurance);
